import { useCallback, useEffect, useRef } from 'react';

import { monitoringExceptionHelper } from 'instrumentation/helpers';
import { green } from '@kizen/kds/Colors';

const DEPLOYMENT_KEY = 'deploymentHash';
const FIVE_MINUTES = 5 * 60 * 1000;

export const MonitorDeploymentVersion = ({ history }) => {
  const stagedPathname = useRef(history.location.pathname);
  const needReload = useRef(false);

  const poll = useCallback(async () => {
    try {
      const hashResponse = await fetch('/meta.txt');
      const hash = await hashResponse.text();

      // if file is unavailable the app's html is going to be fetched instead
      if (!hash || hash.toLowerCase().startsWith('<!doctype html>')) {
        monitoringExceptionHelper(
          new Error(hash ? '/meta.txt not found' : '/meta.txt is empty')
        );
      }

      const storedHash = sessionStorage.getItem(DEPLOYMENT_KEY);

      if (hash && !storedHash) {
        sessionStorage.setItem(DEPLOYMENT_KEY, hash);
      } else if (hash && storedHash !== hash) {
        sessionStorage.setItem(DEPLOYMENT_KEY, hash);
        console.log(
          `%cA new deployment version detected, hash - ${hash}`,
          `color: ${green['green-800']};`
        );
        needReload.current = true;
      }
    } catch (err) {
      // we don't want to spam sentry with this error
    }
  }, []);

  useEffect(() => {
    return history.listen(({ pathname }) => {
      if (stagedPathname.current !== pathname) {
        stagedPathname.current = pathname;
        if (needReload.current) {
          window.location.reload();
        }
      }
    });
  }, [history]);

  useEffect(() => {
    poll();
    const interval = setInterval(() => {
      poll();
    }, FIVE_MINUTES);
    return () => clearInterval(interval);
  }, [poll]);

  return null;
};
